export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 200,
      // render: 'sortRender',
    },
    {title: '名称', dataIndex: 'brandName', width: 160, ellipsis: true},
    {title: '最后修改时间', dataIndex: 'lastUpdatedTime', width: 180, itemType: 'dateTime'},
    {title: '操作', dataIndex: '#', width: 140, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {
      name: 'brandNameKeyword',
      label: '名称',
    }
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
